export const actions = {
    SHOW_QUANTITY_AND_PRICE: 'SHOW_QUANTITY_AND_PRICE',
    HIDE_QUANTITY_AND_PRICE: 'HIDE_QUANTITY_AND_PRICE',
    SHOW_FITTING_STATION_DETAILS: 'SHOW_FITTING_STATION_DETAILS',
    HIDE_FITTING_STATION_DETAILS: 'HIDE_FITTING_STATION_DETAILS',
    SHOW_LIGHT_BOX: 'SHOW_LIGHT_BOX',
    HIDE_LIGHT_BOX: 'HIDE_LIGHT_BOX',
};
